class ModalService {
    callbackModal(
        resource: string,
        settings?: Record<string, any>,
        handler?: HTMLElement,
    ) {
        if (window.ModalServiceKlen) {
            new window.ModalServiceKlen(resource, settings, handler);
        }
    }
}

export const modalService = new ModalService();
